import * as React from 'react'
import Translation from '../../containers/Translation';
import { T_LOADING } from '../../api/translations';

import('./StatsHeadToHeadStyles.scss')   



// get the value in percent of how often valueA fits in valueB
const calcFractionalFittingInPercent = (valueA:number, valueB:number) => {
    if (valueA < 1) {
        return 5
    }
    let relation = (valueA / valueB * 100);

    // now we scale the value a little bit to have a nice presentation
    return relation / 3 * 2
}

const isWinner = ( goalsHome: number, goalsAway: number ) => {
    return goalsHome < goalsAway ? 'away' : 'home'
}

const StatsHeadToHeadPresentation = ( props: { matches: any[], maxGoals: number } ) => {
    if( props.matches && props.matches.length ) {
        return (
            <div className="headToHeadWrapper">
                {  props.matches.map( (match: any, index: number) => headToHeadMatchTemplate( match.home, match.away, props.maxGoals, index) )}
            </div>
        )
    }
    else {
        return (
            <div className={'headToHeadWrapper sr-grid sr-align-center'}>
                <div className="sr-cell sr-stats-loading"><Translation tag={T_LOADING} /></div>
            </div>
        );
    }
}

const headToHeadMatchTemplate = (goalsHome: number, goalsAway: number, maxGoals: number, index: any) => {
    return (
        <div key={index} className={`matchWrapper matchWrapper-${index} ${isWinner(goalsHome, goalsAway)}`}>
            <div className="home graphWrapper">
                <div className="homeGraph graph" style={{width: `${calcFractionalFittingInPercent(goalsHome, maxGoals)}%`}}>&nbsp;</div>
            </div>
            <div className={`scoreWrapper ${isWinner(goalsHome, goalsAway)}`}>
                {goalsHome} : {goalsAway}
            </div>
            <div className="away graphWrapper">
                <div className="awayGraph graph" style={{width: `${calcFractionalFittingInPercent(goalsAway, maxGoals)}%`}}>&nbsp;</div>
            </div>
        </div>
    )
}

export default StatsHeadToHeadPresentation
